import React from "react";
import { Link } from "react-router-dom";
import { apiDtfMenungguAcc, formatApiErrorDetail } from "@/lib/api";
import { rupiah, rencanaTeks } from "@/lib/format";
import AccPanel from "@/components/AccPanel";

// F1.5-G/I: DTF orders whose customer has not approved the design yet:
// upload the mockup, send the ACC link, or record an ACC received over WhatsApp.
export default function DtfMenungguAcc() {
  const [rows, setRows] = React.useState(null);
  const [error, setError] = React.useState(null);
  const load = React.useCallback(() => apiDtfMenungguAcc().then(setRows).catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message)), []);
  React.useEffect(() => { load(); }, [load]);
  if (!rows || rows.length === 0) return error ? <p className="text-xs text-red-300">{error}</p> : null;
  return (
    <div data-testid="dtf-menunggu-acc" className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-4 space-y-3">
      <div className="text-sm font-bold text-soq-biru">Order DTF menunggu ACC customer ({rows.length}) · <Link to="/acc-mockup" className="text-cyan-300 normal-case">buka ACC & Mockup</Link></div>
      {rows.map((r) => (
        <div key={r.order_id} data-testid={`dtf-acc-${r.nomor_faktur}`} className="space-y-1">
          <div className="flex flex-wrap items-center gap-3 text-sm">
            <span className="font-mono text-amber-300">{r.nomor_faktur}</span><span>{r.customer}</span>
            <span className="text-xs text-slate-400">{r.items.join(", ")} · {rupiah(r.total)} · rencana {rencanaTeks(r)}</span>
          </div>
          <AccPanel orderId={r.order_id} jenis="DTF" acc={{ status: r.acc_status, catatan: r.catatan_revisi }} onChanged={load} testid={`dtf-acc-panel-${r.nomor_faktur}`} />
        </div>
      ))}
    </div>
  );
}
